const initialState = {
    nomeCompleto: '',
    dataFimVigencia: null,
    dataInicioVigencia: Date.now(),
    cargo: '',
    assinaturaSuspensa: false,
    portaria: '',
    id: 0
};

const initialStateAssinaturaVigente = {
  nomeCompleto: '',
  dataFimVigencia: null,
  dataInicioVigencia: null,
  cargo: '',
  assinaturaSuspensa: false,
  portaria: '',
  id: 0
};

export const assinaturaVigenteReducer = (state = initialStateAssinaturaVigente, action) => {
  switch (action.type) {
    case 'assinaturaVigente':
      if(!action.payload)
        return state;

      if(action.payload.dataInicioVigencia){
        action.payload.dataInicioVigencia = new Date(action.payload.dataInicioVigencia);
      }
      if(action.payload.dataFimVigencia){
        action.payload.dataFimVigencia = new Date(action.payload.dataFimVigencia);
      }
      return action.payload;
    default:
      return state;
  }
};

export const assinaturaReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'nomeCompleto':
      return { ...state, "nomeCompleto": action.payload };
    case 'dataFimVigencia':
      return { ...state, "dataFimVigencia": action.payload };
    case 'dataInicioVigencia':
      return { ...state, "dataInicioVigencia": action.payload };
    case 'cargo':
      return { ...state, "cargo": action.payload };
    case 'assinaturaSuspensa':
      return { ...state, "assinaturaSuspensa": action.payload };
    case 'portaria':
      return { ...state, "portaria": action.payload };
    case 'id':
      return { ...state, "id": action.payload };
    case 'object':
      return action.payload;
    default:
      return state;
  }
};